import Vue from 'vue'

const employeeType = {
  state: {
    employeeType: [],
    selectedEmployeeType: {},
  },

  getters: {
    employeeType(state) {
      return state.employeeType
    },
    selectedEmployeeType(state) {
      return state.selectedEmployeeType
    },
  },

  mutations: {
    employeeType(state, payload) {
      state.employeeType = payload
    },
    selectedEmployeeType(state, payload) {
      state.selectedEmployeeType = JSON.parse(JSON.stringify(payload))
    },
  },

  actions: {
    setSelectedEmployeeType(context, payload) {
      context.commit('selectedEmployeeType', payload)
    },
    loadEmployeeType(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'EmployeeType'
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('employeeType', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    loadSelectedEmployeeType(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'EmployeeType/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedEmployeeType', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    updateEmployeeType(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `EmployeeType/${payload.ID}`
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'employee type updated'},
              {root: true}
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadEmployeeType')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    createEmployeeType(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `EmployeeType`
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'employee type created'},
              {root: true}
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadEmployeeType')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    saveEmployeeType(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateEmployeeType', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createEmployeeType', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteEmployeeType(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `EmployeeType/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'employee type deleted'},
              {root: true}
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadEmployeeType')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
  },
}

export default employeeType
